import request from '@/utils/request'

let FilialeApi = {

  /*招商中心列表*/
  list(data) {
    return request._post('/shop/plus.filiale.filiale.Index/index', data);
},
/*添加招商中心*/
add(data) {
    return request._post('/shop/plus.filiale.filiale.Index/add', data);
},
/*修改招商中心*/
edit(data) {
    return request._post('/shop/plus.filiale.filiale.Index/edit', data);
},
/*删除招商中心*/
del(data) {
    return request._post('/shop/plus.filiale.filiale.Index/del', data);
},
/*招商中心详情*/
detail(data) {
  return request._post('/shop/plus.filiale.filiale.Index/detail', data);
},
//获取
getDetail(data) {
  return request._post('/shop/plus.filiale.filiale.Index/getDetail', data);
},
//获取设备收入
log(data){
  return request._post('/shop/plus.filiale.filiale.Index/log', data);
},
//获取套餐
package(data){
  return request._post('/shop/plus.filiale.filiale.Index/package', data);
},
//获取设备所属
belong(data){
  return request._post('/shop/plus.filiale.filiale.Index/belong', data);
},
//设备套餐详情
detail_package(data) {
  return request._post('/shop/plus.filiale.filiale.Index/detail_package', data);
},//添加设备套餐
add_package(data) {
  return request._post('/shop/plus.filiale.filiale.Index/addpackage', data);
},
//修改设备套餐
edit_package(data) {
  return request._post('/shop/plus.filiale.filiale.Index/editpackage', data);
},
//删除设备套餐
del_package(data) {
  return request._post('/shop/plus.filiale.filiale.Index/delpackage', data);
},

saveSetting(data, errorback) {
  return request._post('/shop/plus.filiale.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.filiale.Setting/getSetting', data, errorback);
},

setBelongStatus(data){
  return request._post('/shop/plus.filiale.filiale.Index/setBelongStatus', data);
},
setStatus(data){
  return request._post('/shop/plus.filiale.filiale.Index/setStatus', data);
},
getFileUser(data){
  return request._post('/shop/plus.filiale.filiale.Index/getFileUser', data);
}

}
export default FilialeApi;



// WEBPACK FOOTER //
// ./src/api/filiale.js